import { tokens, customScrollbar } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	gap: 24px;
`;

export const Header = styled.div`
	display: grid;
	gap: 24px;
	margin-top: 16px;
`;

export const TableWrapper = styled.div`
	height: 300px;
	overflow: hidden scroll;

	table {
		width: 100%;
	}

	${customScrollbar}
`;

export const HeaderRow = styled.tr`
	height: 40px;
	position: sticky;
	top: 0px;
	z-index: 1;
	background-color: ${tokens.color_gray_light};
`;

export const TableHead = styled.th<{ $width: string }>`
	width: ${({ $width }) => $width} !important;
	padding: 10px;
	font-size: 14px;
	font-weight: 600;
	font-family: ${tokens.font_family_primary};
	color: ${tokens.color_gray_dark};
	text-align: left;
`;

export const TableCell = styled.td`
	padding: 10px;
	border-bottom: 1px solid ${tokens.color_gray_light};
	background-color: ${tokens.color_white};
	font-size: 14px;
	font-weight: 500;
	font-family: ${tokens.font_family_primary};
	color: ${tokens.color_gray_dark};

	.heart-icon {
		width: 20px;
		height: 20px;
	}

	.pending {
		& > path {
			fill: ${tokens.color_gray_medium};
		}
	}
`;

export const Disclaimer = styled.div`
	display: flex;
	gap: 40px;
	margin-top: 16px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
